// 契約書確認
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Heading from '../../molecules/Heading';
import TransitionButton from '../../molecules/TransitionButton';
import { handleBrowserBack } from '../../BrowserBack';
import { isBrowserIe } from '../../BrowserJudgment';
import CenterButton from '../../atoms/CenterButton';
import ShowDocument from '../../molecules/ShowDocument';
import axios from '../../axios';
import LoadingModal from '../../molecules/LoadingModal';
import RowTemplate from '../../atoms/RowTemplate';
import Messages from '../../molecules/Messages';
import { InputGroup } from 'react-bootstrap';
import { getContractName } from '../../Common';
import { isBrowserIOSSafari, isBrowserIpadSafari } from '../../BrowserJudgment';
import { releaseBrowserBack } from '../../BrowserBack';
interface ContractDocument {
  id: number;
  contract_name: string;
  file_name: string;
  base64: string;
}

const ConfirmContract = () => {
  const [contract_document, setContractDocument] = useState<ContractDocument[]>([]);
  const [active_document, setActiveDocument] = useState<ContractDocument>();
  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const r_id = url_params.get('r_id');
  // // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(false);
  // ダウンロードボタンの活性・非活性制御 true:非活性 false:活性
  const [is_download_disabled, setIsDownloadDisabled] = useState<boolean>();

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 表示するPDFの取得
    getDocument();
  }, []);

  // 表示する契約書情報の取得
  const getDocument = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_contract_document`,
        {
          params: { r_id: r_id },
        }
      );
      setContractDocument(response.data);
      changeDocument(response.data[0]);
      setIsDownloadDisabled(false);
    } catch (error) {
      console.error(error);
      setIsDownloadDisabled(true);
      alert(error.response.data.message);
    }
    setIsLoading(false);
  };

  // ラジオボタンの選択、初回表示する書類の設定
  const changeDocument = async (document: ContractDocument) => {
    // 表示するPDFの変更
    setActiveDocument(document);

    // 表示するPDFを「確認済み」にする
    try {
      await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/confirmed_document`, {
        r_id: r_id,
        document_id: document.id,
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.message);
    }
  };

  // 契約書のダウンロード処理
  const handleClick = () => {
    try {
      setIsLoading(true);

      //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
      if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
        releaseBrowserBack();
      }

      // 契約書名を取得
      const file_name = getContractName(active_document?.contract_name);

      //ファイルをダウンロードする。
      const url = `${location.origin}${process.env.MIX_MOCK_URL}/api/download_contract_document?file_id=${active_document?.id}`;
      const self_download_link = document.createElement('a');
      document.body.appendChild(self_download_link);
      self_download_link.download = `${file_name}.pdf`;
      self_download_link.href = url;
      self_download_link.click();
      self_download_link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  // 「戻る」ボタン押下時
  const backTransition = () => {
    if (isBrowserIe()) {
      const node = document.getElementById('confirm-contract');
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <>
      <Heading label="契約書確認" size="l" />
      <div>
        <RowTemplate
          label="契約書の選択"
          display_border
          content={
            <div className="p-radio">
              <InputGroup>
                {contract_document.map(document => {
                  return (
                    <label className="radio-label" key={document.id}>
                      <input
                        type="radio"
                        name="contract_document"
                        defaultChecked={document.id === contract_document[0].id}
                        onChange={() => changeDocument(document)}
                        className="input-radio"
                      />
                      <span className="radio-icon"></span>
                      <div>{document.contract_name}</div>
                    </label>
                  );
                })}
              </InputGroup>
              <Messages help_msg="※選択に応じてプレビューおよびダウンロードされる契約書が切り替わります" />
            </div>
          }
        />
      </div>
      <div className="container-box my-5">
        {active_document && <ShowDocument url={active_document.base64} />}
        <div className="my-5"></div>
        <CenterButton
          label="ダウンロード"
          handleClick={handleClick}
          is_disabled={is_download_disabled}
        />
        <TransitionButton label="戻る" handleClick={backTransition} />
      </div>
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('confirm-contract')) {
  render(<ConfirmContract />, document.getElementById('confirm-contract'));
}
